//3rd Party Components
import React, { Fragment, useEffect  } from 'react';
import { useSelector } from "react-redux";
import MetaTags from 'react-meta-tags';
import * as msal from "@azure/msal-browser";

//Components
import CASASpinner from '../components/Portal/CASASpinner';
import { getPortalUrl } from '../components/Portal/Utilities';

export const LogoutPage = () => {

    let B2CSettings = useSelector(state => state.B2CSettings.items);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
        
    useEffect(() => {
        let homeUrl = getPortalUrl("/signedout", standalone, "") + "&signout=1";
        var mc = {
            auth: {
                clientId: B2CSettings.AuthClientId,
                authority: B2CSettings.SignUpAuthority,
                knownAuthorities: [B2CSettings.AuthAuthority],
                postLogoutRedirectUri: homeUrl
            },
            cache: {
                cacheLocation: "sessionStorage",
                storeAuthStateInCookie: false
            }
        };    
        let msalInstance = new msal.PublicClientApplication(mc);

        const currentAccounts = msalInstance.getAllAccounts();

        const logoutRequest = { 
            account: msalInstance.getAccountByUsername(currentAccounts[0].username)
        }
        msalInstance.logout(logoutRequest);
        
    }, [B2CSettings, standalone]);
   
    return (
        <Fragment>
            
            <MetaTags>
                <title>Logged Out</title>
            </MetaTags>

            <CASASpinner message="Signing out.."></CASASpinner>

        </Fragment>
    )
    
}
